import { type FC } from 'react';
import { useIntl, defineMessages } from 'dibs-react-intl';
import { useFragment, graphql } from 'react-relay';
import classNames from 'classnames';
import { Link } from 'dibs-elements/exports/Link.tsx';

import { DIRECTORY_PATH } from '../constants.ts';

import styles from './ProjectBreadcrumbs.scss';

import { type ProjectBreadcrumbs_searchResult$key } from './__generated__/ProjectBreadcrumbs_searchResult.graphql.ts';

type ProjectBreadcrumbsProps = {
    searchResult: ProjectBreadcrumbs_searchResult$key | null | undefined;
};

const messages = defineMessages({
    designFirmsCrumb: {
        id: 'abt.interiorProject.breadcrumbs.designFirms',
        defaultMessage: 'Design Firms',
    },
});

export const ProjectBreadcrumbs: FC<ProjectBreadcrumbsProps> = ({
    searchResult: searchResultRef,
}) => {
    const searchResult = useFragment(
        graphql`
            fragment ProjectBreadcrumbs_searchResult on TradeInteriorProjectQueryOutput {
                firm {
                    publicProfile {
                        urlLabel
                    }
                    name
                }
                project {
                    name
                }
            }
        `,
        searchResultRef
    );
    const intl = useIntl();
    const firm = searchResult?.firm;
    const project = searchResult?.project;

    const firmUrlLabel = firm?.publicProfile?.urlLabel || '';
    const firmName = firm?.name || '';
    const displayFirmCrumbs = firmUrlLabel && firmName;

    return (
        <div className={classNames(styles.wrapper, 'colSm12')}>
            <div className={styles.crumb}>
                <Link href={DIRECTORY_PATH} className={styles.crumbLink}>
                    {intl.formatMessage(messages.designFirmsCrumb)}
                </Link>
            </div>
            <div className={styles.crumb}>/</div>
            {displayFirmCrumbs && (
                <>
                    <div className={styles.crumb}>
                        <Link
                            href={`${DIRECTORY_PATH}${firmUrlLabel}/`}
                            className={styles.crumbLink}
                        >
                            {firmName}
                        </Link>
                    </div>
                    <div className={styles.crumb}>/</div>
                </>
            )}
            <div className={styles.crumb}>{project?.name}</div>
        </div>
    );
};
